import './bannerhome.css';
import banner from '../../img/woman1.png';
import phonelogo from '../../img/phone.png';
import { Link } from 'react-router-dom';
import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

export default function BannerHome(props) {
    const mountRef = useRef(null);
    const modelRef = useRef(null);

    useEffect(() => {
        const scene = new THREE.Scene();
        // scene.background = new THREE.Color(209, 203, 203);
        
        const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
        camera.position.set(0, 1, 5);

        const renderer = new THREE.WebGLRenderer({ alpha: true });
        renderer.setSize(window.innerWidth, window.innerHeight);
        mountRef.current.appendChild(renderer.domElement);

        const ambientLight = new THREE.AmbientLight(0xffffff, 0.8); // نور محیطی
        scene.add(ambientLight);
    
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5); // نور جهت‌دار ملایم
        directionalLight.position.set(5, 5, 5);
        scene.add(directionalLight);

        const loader = new GLTFLoader();
        loader.setPath('/3d/');
        loader.load(
            'scene.gltf',
            (gltf) => {
                modelRef.current = gltf.scene;
                modelRef.current.scale.set(0.3, 0.3, 0.3);
                modelRef.current.position.set(1.7, 0.7, 0);
                scene.add(modelRef.current);
            },
            undefined,
            (error) => {
                console.error("An error occurred while loading the GLTF model:", error);
            }
        );

        const animate = () => {
            requestAnimationFrame(animate);
            if (modelRef.current) {
                modelRef.current.rotation.y += 0.01;
            }
            renderer.render(scene, camera);
        };

        animate();

        return () => {
            // بررسی وجود mountRef و جلوگیری از ارور
            if (mountRef.current && mountRef.current.firstChild) {
              mountRef.current.removeChild(renderer.domElement);
            }
            renderer.dispose(); // پاکسازی renderer
          };
        }, []);

    return (
<div className='bannerhome'>
    <div className='model-container' ref={mountRef}></div>
    <div className='backgroundbanner'></div>
    <img className='mainbanner' src={banner} alt='banner' />
    <div className='infobanner'>
        <h2>به آکادمی MAHOGANY خوش آمدید</h2>
        <p>ارائه خدمات زیبایی و آرایشگاهی، با بهترین متخصصین زیبایی در خدمت شما هستیم.</p>
        <p>ما را به دوستان خود معرفی کنید.</p>
        <Link to='/contact' onClick={() => props.setSelectnav('/contact')}>
            <img src={phonelogo} alt='contact' />
            <p>تماس با ما</p>
        </Link>
    </div>
</div>

    );
}
